import {
  BookOpenTextIcon,
  EyeIcon,
  ImageIcon,
  KeyIcon,
  ShareNetworkIcon,
} from "@codat/orchard-ui";
import { Product } from "api/schema/productsSchema";
import React from "react";
import { getProductDetails, productIds } from "utils";

import { paths } from "../App/paths";

export const getCardInfo = (product: Product | undefined) => {
  const { learnMoreLinkHref, apiDocsHref } = getProductDetails(product);

  const productOverviewCard = {
    headerIcon: <ImageIcon data-testid="landscape-icon" />,
    headerText: "Product overview",
    description:
      "View our product documentation and understand how to make the most of Codat.",
    buttonName: "Read the docs",
    linkToNavigate: learnMoreLinkHref,
    newWindowIcon: true,
    testId: "product-overview-card",
    isInternalLink: false,
  };

  switch (product?.productId) {
    case productIds.spendInsights:
      return [
        productOverviewCard,
        {
          headerIcon: <ShareNetworkIcon data-testid="share-icon" />,
          headerText: "Invite a company",
          description: "Get access to your customer's data today.",
          buttonName: "Create company",
          linkToNavigate:
            "/companies?newCompany=true&newCompanyProducts=supplier-enablement",
          newWindowIcon: false,
          testId: "invite-company-card",
          isInternalLink: true,
        },
        {
          headerIcon: <EyeIcon data-testid="eye-icon" />,
          headerText: "View spend insights",
          description:
            "Find out how to view and download insights once available.",
          buttonName: "Downloading insights",
          linkToNavigate:
            "https://docs.codat.io/spend-insights/guides/analyze-spend",
          newWindowIcon: true,
          testId: "view-spend-insights-card",
          isInternalLink: false,
        },
      ];
    default:
      return [
        {
          headerIcon: <KeyIcon data-testid="key-icon" />,
          headerText: "API keys",
          description:
            "Admin and Developer users can access API keys to authenticate use of Codat APIs.",
          buttonName: "Get your API keys",
          linkToNavigate: paths.developers.API_KEYS,
          testId: "api-keys-card",
          isInternalLink: true,
        },
        productOverviewCard,
        {
          headerIcon: <BookOpenTextIcon data-testid="book-icon" />,
          headerText: "API reference",
          description: product
            ? "You can explore this product's API and its endpoints in our API references."
            : "Explore Codat's data model and see the information you can access.",
          buttonName: "See the API ref",
          linkToNavigate: apiDocsHref,
          newWindowIcon: true,
          testId: "api-reference-card",
          isInternalLink: false,
        },
      ];
  }
};
